import { O_FETCH_SUGGESTIONS, O_FETCH_SEARCH } from './constants'

export const fetchSuggestions = {
  request: query => ({ type: O_FETCH_SUGGESTIONS.REQUEST, query }),
  success: results => ({ type: O_FETCH_SUGGESTIONS.SUCCESS, results })
}

export const fetchSearch = {
  request: (query, filters, pageNumber, pageLength) => ({
    type: O_FETCH_SEARCH.REQUEST,
    query,
    filters,
    pageNumber,
    pageLength
  }),
  success: searchResults => ({
    type: O_FETCH_SEARCH.SUCCESS,
    searchResults
  })
}
